<template>
  <div class="main mainIndicG">
    <div class="indicateur-section">
      <div class="wrapPortable Indica">
        <div>
          <h1 class="indH1">{{ info[activetab-1].title }}</h1>
          <h2 class="indH2">{{ info[activetab-1].underTitle }}</h2>
        </div>
        <!--
          <div class="alert alIndicateur" v-if="dr > 1 && activetab > 1">
              <p class="pimage">
                <img src="../assets/logo/logo-info.png" alt="logo-info" class="logo-alert"/>
              </p>
              <p class="alert-info">
                Vous pouvez revenir en arrière en sélectionnant la page concernée.
            </p>
            </div>
        -->
      </div>

      <div id="Tabs" class="Container indicateurTabContainer">
        <div class="Tabs">
          <!--<a v-for="tab in tabs" :key="tab.name" v-on:click="activetab = tab.name" v-bind:class="[ activetab === tab.name ? 'active' : '' ]">{{tab.name}}</a>-->
          <ul>
            <li
              v-for="tab in tabs"
              :key="tab.name"
              v-on:click="verifPosition(tab.name)"
              v-bind:class="[ activetab === tab.name ? 'active' : '', activetab > tab.name ? 'passed' : '']"
            >
              <p>{{tab.name}}</p>
            </li>
          </ul>
        </div>

        <div class="Content">
          <div v-if="activetab === 1" class="tabcontent indtab">
            <Indicateur1></Indicateur1>
          </div>
          <div v-if="activetab === 2" class="tabcontent">
            <Indicateur2></Indicateur2>
          </div>
          <div v-if="activetab === 3" class="tabcontent indtab">
            <Indicateur3 @goValider="kokoValid()"></Indicateur3>
          </div>
          <div v-if="activetab === 4" class="tabcontent indtab">
            <Indicateur4 @goValider="kokoValid()"></Indicateur4>
          </div>

          <div v-if="activetab === 5" class="indtabcontent resultatInd">
            <h2
              class="indH2"
            >Merci d'avoir rempli ces informations ! Vous allez être redirigés vers l'Accueil</h2>
            <router-link
              to="Accueil"
              class="submitQuestionnaire finVideoBoutton subFifi"
              title="retour Accueil"
              v-if="afficheAcc == true">
            Accueil</router-link>
          </div>
        </div>
      </div>
      <div class="subTest">
        <button
          :class="['submitQuestionnaire', activetab == 4 && validerOk == true ? 'subFifi' : '', activetab == 2 ? 'sub2': '', activetab == 1 ? 'sub1': '']"
          v-if="activetab < 3 || validerOk == true"
          v-on:click="updateData()"
        >Valider</button>
        <!--<button class="submitQuestionnaire" v-if="activetab == 5" v-on:click="postData()" required>Envoyer les Résultats</button>-->
      </div>
    </div>
  </div>
</template>

<script>
import Indicateur1 from "@/components/indicateur/Indicateur_1";
import Indicateur2 from "@/components/indicateur/Indicateur_2";
import Indicateur3 from "@/components/indicateur/Indicateur_3";
import Indicateur4 from "@/components/indicateur/Indicateur_4";
import { hostUrl } from "../_helpers/global_var";
import { User } from "../controller/user.js";

const axios = require("axios").default;

export default {
  name: "Test",
  components: {
    Indicateur1: Indicateur1,
    Indicateur2: Indicateur2,
    Indicateur3: Indicateur3,
    Indicateur4: Indicateur4,
  },

  data() {
    return {
      dr: 1,
      activetab: 1,
      tabs: [{ name: 1 }, { name: 2 }, { name: 3 }, { name: 4 }],
      info: [
        {
          title: "Vos douleurs Musculo-squelettiques",
          underTitle: "Depuis 1  An",
        },
        {
          title: "Vos douleurs Musculo-squelettiques",
          underTitle: "Durant l'année écroulée",
        },
        {
          title: "Vos douleurs Musculo-squelettiques",
          underTitle: "Durant l'année écroulée",
        },
        {
          title: "Vos douleurs Musculo-squelettiques",
          underTitle: "Durant l'année écroulée",
        },
        { title: "Résumé", underTitle: "Resultats" },
      ],
      testResult: [],
      user: JSON.parse(localStorage.user) || [],
      testsInitialises: false,
      validerOk: false,
      afficheAcc: false
    };
  },
  created() {
    if (typeof localStorage.user !== undefined) {
      this.user = JSON.parse(localStorage.user);
      if (this.user.liste_Metier !== [] && this.user.liste_Metier.length > 0) {
        this.tableau_profession = this.user.liste_Metier;
        //console.log(this.user.liste_Metier.length);
      }
      //console.log(this.user);
    } else {
      console.log("var not exist");
    }
  },

  methods: {
    defineTest(index) {
      let balise = "<" + index + "></" + index + ">";
      return balise;
    },
    even(numbers, activetab) {
      return numbers.filter(function (number) {
        return number === activetab;
      });
    },
    updateData() {
      //-----------------Indic 1------------------
      if (
        this.testResult["Indicateur1"] == null &&
        localStorage.indicateur1 !== undefined
      ) {
        let array = JSON.parse(localStorage.indicateur1);
        this.testResult["Indicateur1"] = array;
        console.log(this.testResult["Indicateur1"]);
        if (this.testResult["Indicateur1"] == null || this.testResult["Indicateur1"].travail == null &&
          this.testResult["Indicateur1"].maison == null  ){
            return alert('vous n\'avez pas selectionner de réponse !');
          }
        if (
          this.testResult["Indicateur1"].travail == false &&
          this.testResult["Indicateur1"].maison == false
        ) {
          return this.postData(true);
        }
        //-----------------test 2------------------
      } else if (this.testResult["Indicateur2"] == null) {
        var corps = document.getElementsByClassName("ind-active");
        var array = [];
        Object.keys(corps).forEach(function (element, index) {
          array.push(corps[element].textContent);
        });

        this.testResult["Indicateur2"] = array;
        console.log(this.testResult["Indicateur2"]);
        //-----------------test 3------------------
      } else if (
        this.testResult["Indicateur3"] == null &&
        localStorage.indicateur3 !== undefined
      ) {
        let array = JSON.parse(localStorage.indicateur3);
        var echelle = document.getElementById("douleurEchelle").value;
        array.push(echelle);
        this.testResult["Indicateur3"] = array;
        console.log(this.testResult["Indicateur3"]);
        this.validerOk = false;
        //-----------------test 4------------------
      } else if (
        this.testResult["Indicateur4"] == null &&
        localStorage.indicateur4 !== undefined
      ) {
        var corps2 = document.getElementsByClassName("actived");

        let array = JSON.parse(localStorage.indicateur4);
        Object.keys(corps2).forEach(function (element, index) {
          array.push({ changementPro: corps2[element].textContent });
        });
        this.testResult["Indicateur4"] = array;
        console.log(this.testResult["Indicateur4"]);
        this.validerOk = false;
      }
      this.majActivtab();
    },
    majActivtab() {
      if (this.activetab >= 1 && this.activetab < 5) {
        this.activetab++;
        this.dr++;
      } else if (this.activetab == 5) {
        this.activetab = 6;
      }
      if (this.activetab == 5) {
        setTimeout(() => {
          this.postData();
        }, 3000);
      }
    },
    calcImc() {
      var imc = this.user.poids / Math.pow(this.user.taille, 2);
      imc = Number(imc);
      return Number.parseFloat(imc).toFixed(1);
    },
    async postData(touVaBien = null) {
      let id = this.user.salarie_id;
      if (touVaBien !== true) {
        let json = JSON.stringify([
          { indicateur: 1, resultat: this.testResult["Indicateur1"] },
          { indicateur: 2, resultat: this.testResult["Indicateur2"] },
          { indicateur: 3, resultat: this.testResult["Indicateur3"] },
          { indicateur: 4, resultat: this.testResult["Indicateur4"] },
        ]);
        console.log(json);
        await axios
          .post(hostUrl + "/salarie/edit/douleur/" + id, json)
          .then((response) => console.log(response.data))
          .then((localStorage.refaireDoudou = false))
          .catch((error) => console.log(error));
      } else {
        let json = JSON.stringify([
          { indicateur: 1, resultat: this.testResult["Indicateur1"] },
        ]);
        console.log(json);
        await axios
          .post(hostUrl + "/salarie/edit/douleur/" + id, json)
          .then((response) => console.log(response.data))
          .then((localStorage.refaireDoudou = false))
          .catch((error) => console.log(error));
      }

      let arrayUser = JSON.stringify({
        mail: this.user.mail,
        password: this.user.password,
      });
      await axios

        .post(hostUrl + "/salarie", arrayUser)
        .then((response) => this.userOk(response, this.user.password))
        .catch((error) => console.log(error));
    },
    userOk(response, pass) {
      if (
        typeof localStorage.resultats !== undefined &&
        localStorage.length > 2 &&
        localStorage.resultats !== "[]" &&
        localStorage.resultats !== "undefined" &&
        localStorage.resultats !== undefined
      ) {
        this.testsInitialises = true;
      } else {
        this.appelApi().then(function () {
          if (typeof localStorage.resultats !== "undefined") {
            try {
              let tests = JSON.parse(localStorage.resultats);
              if (
                tests.lenght !== 0 &&
                tests !== null &&
                tests !== [] &&
                test !== undefined &&
                test !== "undefined"
              ) {
                console.log(tests);
                this.testsInitialises = true;
              } else {
                this.testsInitialises = false;
              }
            } catch (error) {
              this.testsInitialises = false;
            }
          } else {
            this.testsInitialises = false;
          }
        });
      }
      console.log(this.testsInitialises, localStorage.resultats);
      //console.log(response.data);
      let koko = new User(response.data);
      koko.password = pass;
      localStorage.removeItem("user");
      localStorage.user = JSON.stringify(koko);
      //console.log(localStorage.user);
      if (this.testsInitialises == false) {
        this.$router.push({ name: "Test" });
      } else {
        this.$router.push({ name: "Accueil" });
      }

      this.afficheAcc = true;
    },
    verifPosition(data) {
      if (this.dr >= this.activetab && this.dr >= data) {
        this.activetab = data;
        //console.log(this.dr);
        if (this.testResult["Indicateur1"] !== null && data == 1) {
          this.testResult["Indicateur1"] = null;
        } else if (this.testResult["Indicateur2"] !== null && data == 2) {
          this.testResult["Indicateur2"] = null;
        } else if (this.testResult["Indicateur3"] !== null && data == 3) {
          this.testResult["Indicateur3"] = null;
        } else if (this.testResult["Indicateur4"] !== null && data == 4) {
          this.testResult["Indicateur4"] = null;
        }
      }
    },
    async appelApi() {
      await axios
        .get(hostUrl + "/salarie/infoResultat/" + this.user.salarie_id)
        .then(
          (response) => (localStorage.resultats = JSON.stringify(response.data))
        )
        .catch((error) => console.log(error));
    },
    kokoValid() {
      console.log("koko");
      this.validerOk = true;
    },
  } /*
  watch: {
    '$route' (to, from) {
      console.log(from.name, this.activetab)
      if(from.name == 'Indicateur' && this.activetab > 1){
        alertConfig={
                      //boxBgClass:"myButton", //Background class
                      boxBgColor:"#54c7da",
                      //boxBtnCloseClass:"myButton", //Button close class
                    };
        alert('Vous pouvez revenir en arrière en sélectionnant la page concernée, dans le chemin de fer au dessous tu titre.');
      }else{
        next();
      }
  }
},*/,

  beforeRouteLeave: (to, from, next) => {
    try {
      var koko = JSON.parse(localStorage.user);
    } catch (error) {
      var koko = new User();
    }

    if (koko.cI !== null) {
      if (
        localStorage.refaireDoudou !== undefined &&
        localStorage.refaireDoudou == true
      ) {
        alert(
          "Il est impératif qui vous ayez réalisé ce questionnaire, vous pourrez accéder aux autres pages une fois qu'il sera validé"
        );
        next(false);
      }
    } else {
      if (
        localStorage.refaireDoudou !== undefined &&
        localStorage.refaireDoudou == true
      ) {
        alert(
          "Il est impératif qui vous ayez réalisé ce questionnaire, vous pourrez accéder aux autres pages une fois qu'il sera validé"
        );
        next(false);
      }

      if (this.testsInitialises == false) {
        console.log("here");
        next("Test");
      } else {
        next();
      }
    }
  },
};
</script>
<style>
.mainIndicG{
  overflow-x: hidden;
}
.indicateur-section {
  width: 100%;
  height: 100%;
  min-height: 725px;
}
.Indica {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 30px;
}
.alIndicateur {
  width: 40%;
  height: 80%;
  margin: 0;
  padding: 0;
}
.indtab {
  width: 90%;
  margin-right: auto;
  margin-left: auto;
  padding: 0;
  min-height: 440px;
}
.resultatInd {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 90%;
  height: 100%;
  text-align: start;
}
h2.h2Ind2.vueActiveI {
  margin-top: 0 !important;
  top: 0px !important;
}
.subFifi {
  position: absolute;
  top: 102%;
}
.sub2,
.sub1 {
  position: absolute;
  top: 80%;
}
@media only screen and (max-width: 1200px){
.sub1 {
  position: absolute;
  top: 70%;
}
}
@media screen and (min-width: 979px){
  .Indica{
    width: 100%;
    margin-left: 0;
  }
  .indicateurTabContainer .Content{
    background: transparent;
    width: 100%;
  }
  .mainIndicateur0{
    padding: 0 !important;
    height: 42vh !important;
  }
  .mainIndicateur1{
    padding: 0 !important;
    height: 42vh !important;
  }
  .ind2-bloc2, .ind2-bloc3{
    height: 80%;
  }
  .imgb2{
    right: 0px;
    margin-right: auto;
    margin-left: auto;
  }
  .sectionCI1 ul {
    min-height: 210px !important;
    height: 41vh !important;
  }
  .bloc-douleur3 , .bloc-douleur4{
    /*height: 100%;*/
    height: 45vh;
  }
  .douleur3, .douleur4{
    flex-direction: column;
    height: 100%;
  }
    .bloc-douleur3 li, .bloc-douleur4 li{
    width: 100%;
  }
  .mainIndicateur34{
    height: 45vh;
  }
  .ind3-section.ind-sectionSpe .bloc-douleur3{
    height: 35vh;
    width: 90%;
    margin-left: auto;
    margin-right: auto;
  }
  .vueActiveI1 {
    width: 100%;
  }
  .subFifi{
    position: relative !important;
    top: 5px;
    width: 90%;
  }
  .mainIndicG{
    overflow-y: hidden;
  }
  .bld4bis{
    height: 35vh !important;
    margin-left: auto;
    margin-right: auto;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Indicateur.vue